export const gettaskreq="gettaskreq"
export const gettasksucc="gettasksucc"
export const gettaskfail="gettaskfail"